import React from 'react';
import './App.css';
import Auth from './Auth/Auth'
// import IranAuth from './Auth/IranAuth'

import Intro from './Intro/Intro'

import Login from './Auth/Login'
import Register from './Auth/Register'
import RegisterGetPassword from './Auth/RegisterGetPassword'
import Home from './Home/Home'
import GetPhoneNumber from './Auth/GetPhoneNumber'
import CheckVerificationCode from './Auth/CheckVerificationCode'
import ForgetPassword from './Auth/ForgetPassword'
import ForgetPasswordGetCode from './Auth/ForgetPasswordGetCode'
import ChangePassword from './Auth/ChangePassword';
import Coin from './Coin/Coin'
import GetLinkUsername from './Home/GetLinkUsername'
import GetUsernameView from './Home/GetUsernameView'
import Notice from './Home/Notice'
import TransferHistory from './Coin/TransferHistory';
import GiftCode from './Coin/GiftCode'
import Profile from './Profile/Profile'
import AccountInformation from './Profile/AccountInformation'
import Payments from './Profile/Payments'
import LogOut from './Profile/LogOut'
import DeleteAccount from './Profile/DeleteAccount'
import AddNumber from './Profile/AddNumber'
import AddNumberVerify from './Profile/AddNumberVerify'
import EditNumber from './Profile/EditNumber'
import EditNumberVerify from './Profile/EditNumberVerify'
import Privacy from './Profile/Privacy'
import SetPassword from './Profile/SetPassword'
import GetCheckPassword from './Profile/GetCheckPassword'
import GetChangePassword from './Profile/GetChangePassword'

import PhotoUpload from './Profile/PhotoUpload/PhotoUpload'
import Orders from './MyOrder/Orders'
import OrderDetailsSingle from './MyOrder/OrderDetailsSingle'
import OrderDetailsAll from './MyOrder/OrderDetailsAll'
import Game from './Game/Game'
import AllReward from './Game/AllReward/AllReward'
import PreviousTournament from './Game/PreviousTournament/PreviousTournament'
import VerifyTelegramCodeLogin from './AuthTelegram/VerifyTelegramCodeLogin'
import JoinBotLoginTelegram from './AuthTelegram/JoinBotLoginTelegram';


import SellingPhoneNumbers from './Sale/SellingPhoneNumbers'
import SaleHistory from './Sale/SaleHistory'
import VerificationCode from './Sale/VerificationCode'
import EditProfile from './Profile/EditProfile';
import SetName from './Profile/SetName/SetName';
// import "./Public/fonts/font.css"
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import LoginTelegram from './TelegramLogin/LoginTelegram'
import VerifyCode from './TelegramLogin/VerifyCode'
import JoinBot from './TelegramLogin/JoinBot'
import AddEmail from './Profile/AddEmail/AddEmail'
import AddEmailSetPassword from './Profile/AddEmail/SetPassword'
import SelectEmoji from './Home/Reaction/SelectEmoji'
import ReactionGetPostLink from './Home/Reaction/ReactionGetPostLink'

import AutoManualJoin from './Coin/AutoManualJoin';
import Update from './BottomSheet/Update'
import { useState, useRef } from 'react';
import { useEffect } from 'react';

import SnackBarEndLeague from './Game/GlobalGameComponent/SnackBarEndLeague'
import { CheckDataBaseGame } from './GameAction/CheckDataBaseGame'
import { useSelector, useDispatch } from 'react-redux'
import { GetCookie } from './Action/GetCookie';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Congratulations from './Game/BottomSheets/Congratulations'
import Congratulations2 from './Game/BottomSheets/Congratulations2'
import Congratulations3 from './Game/BottomSheets/Congratulations3'
import Promotion from './Game/BottomSheets/Promotion'
import { GameDB } from './DataBase/GameDB'

import { OnlineRequestAppSettingGame } from './GameAction/OnlineRequestAppSettingGame'
import { OnlineRequestProfileGame } from './GameAction/OnlineRequestProfileGame'
import { OnlineRequestLeagueListGame } from './GameAction/OnlineRequestLeagueListGame'
import { OnlineRequestTopJoinerGame } from './GameAction/OnlineRequestTopJoinerGame'

import { TelegramDB } from './DataBase/TelegramDB'

import { GetUserDataFromAppSettingGame } from './GameAction/GetUserDataFromAppSettingGame'
import {
  SetAppSettingData,
  SetUserLeagueData,
  SetMyLeagueRank,
  SetLeagueLimitJoinProgress,
  SetLeagueMinimumJoinProgress,
  SetRewardLeague,
  SetMyLeagueRankNumber,
  SetGiftTopjoin,
  SetNameAccount,
  SetJoinCountRedux,
  SetPromotionBottomSheet,
  SetUserReward,
  SetClaimRewardCall,
  SetDataClaimReward,
  SetXpLimit,
  SetXpCount,
  SetLevelUserHeaderProgress,
  SetSnackBarEndLeagueState,

} from './app/Game'
import { SetLoginTelegramDialogeState } from './app/Home'
import LoginTelegramDialoge from './Dialoge/LoginTelegramDialoge'
import { CheckDataBaseJoin } from './JoinAction/CheckDataBaseJoin'
import axios from "axios";
import data from './Auth/country.json';
// import PushTest from './PushTest'

function App() {


// Register Service Worker
// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register("/sw.js")
//       .then((reg) => console.log("✅ Service Worker registered:", reg.scope))
//       .catch((err) => console.error("❌ Service Worker registration failed:", err));
//   });
// }



  const dispatch = useDispatch()

  const [Mode, setMode] = useState('light')
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    if (mediaQuery.matches) {
      setMode('dark')
    }
  }, [])

  let AuthState = GetCookie('Token')
  const history = useHistory();

  useEffect(() => {
    if (AuthState == null || AuthState == 'null') {
      // history.push(`/`);
    }
  }, [AuthState])





  const CheckDataBaseFunc = async () => {
    const CheckDataBaseGameClass = new CheckDataBaseGame();
    let CheckDataBaseRes = await CheckDataBaseGameClass.CheckDataBase(dispatch)
    return CheckDataBaseRes
  }


  const StartLoop = async (intervalRef1) => {
    const CheckDataBaseGameClass = new CheckDataBaseGame();
    let StartLoopRes = await CheckDataBaseGameClass.LoopOfGame(dispatch, intervalRef1)
    return StartLoopRes
  }
  const UserLeagueData = useSelector((state) => state.Game.UserLeagueData)

  const intervalRef2 = useRef(true);

  const AppSettingData = useSelector((state) => state.Game.AppSettingData)
  const ProfileData = useSelector((state) => state.Game.ProfileData)
  const TopJoinerData = useSelector((state) => state.Game.TopJoinerData)
  const PrevLeagueData = useSelector((state) => state.Game.PrevLeagueData)
  const JoinCountRedux = useSelector((state) => state.Game.JoinCountRedux)
  const ClaimRewardCall = useSelector((state) => state.Game.ClaimRewardCall)
  const PromotionBottomSheet = useSelector((state) => state.Game.PromotionBottomSheet)
  const LeagueWithXp = useSelector((state) => state.Game.leagueWithXp)
  const XpMax = useSelector((state) => state.Game.XpMax)
  const XpMin = useSelector((state) => state.Game.XpMin)
  const XpCount = useSelector((state) => state.Game.XpCount)
  const xpCountLeague = useSelector((state) => state.Game.xpCountLeague)

  useEffect(() => {

    if (ClaimRewardCall == true) {
      dispatch(SetClaimRewardCall(false))

      RequestForDataAfterClaim()
    }
    return () => {

    }
  }, [ClaimRewardCall])
  const RequestForDataAfterClaim = async () => {

    const CheckDataBaseGameClass = new CheckDataBaseGame();
    await CheckDataBaseGameClass.CollectDataAfterClaim(dispatch)


  }
  const calcJoinAndLevel = async (LevelUser) => {

    const GetUserDataFromAppSettingClass = new GetUserDataFromAppSettingGame();
    let ResOfGetUserData = await GetUserDataFromAppSettingClass.GetUserDataFromAppSetting(LevelUser, dispatch)
  }
  const CompareJoinAndLeagueLevelFunction = async (LevelUser, JoinCountRedux, LeagueWithXp, XpMax, XpMin, xpCountLeague) => {
    const CheckDataBaseGameClass = new CheckDataBaseGame();
    let StartLoopRes = await CheckDataBaseGameClass.CompareJoinAndLeagueLevel(dispatch, LevelUser, JoinCountRedux, LeagueWithXp, XpMax, XpMin, XpCount)
  }
  useEffect(() => {

    let LevelUser = false
    if (UserLeagueData.userInformation) {
      LevelUser = UserLeagueData.userInformation.leagueLevel

      calcJoinAndLevel(LevelUser)

    }



  }, [UserLeagueData])
  useEffect(() => {
    CompareJoinAndLeagueLevelFunction(JoinCountRedux, LeagueWithXp, XpMax, XpMin, xpCountLeague)

    return () => {

    }
  }, [JoinCountRedux, xpCountLeague])

  async function waitFor10Seconds() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve('Waiting period of 10 seconds completed.');
      }, 10000);
    });
  }

  const [reswait, setreswait] = useState('light')
  const intervalRef1 = useRef(true);

  useEffect(() => {
    CheckDataBaseFunc()
    intervalRef1.current = setInterval(async () => {
      let res = await StartLoop(intervalRef1)

      if (res == false) {
        clearInterval(intervalRef1.current);
        let wait = await waitFor10Seconds();
        setreswait(wait)
        setTimeout(async () => {
          CheckDataBaseFunc()
          // console.log('reload')
          // window.location.reload();
        }, 5000);
      }
    }, 1000);
  }, [reswait, intervalRef1]);


  const GetTopJoinerCompareWithJoin = async (dispatch) => {
    let TopJoiner = await GameDB.TopJoiner.toArray()
    const OnlineRequestTopJoinerGameClass = new OnlineRequestTopJoinerGame();
    const OnlineRequestLeagueListGameClass = new OnlineRequestLeagueListGame();
    if (TopJoiner[0]) {

      TopJoiner[0].TopJoiner.map(async (item) => {
        if (item.email == TopJoiner[0].userInformation.email) {
          if (TopJoiner[0].userInformation.joinCount == JoinCountRedux) {

            let ResTopJoiner = await OnlineRequestTopJoinerGameClass.OnlineRequestTopJoiner(dispatch)
            let res = await OnlineRequestLeagueListGameClass.OnlineRequestLeagueList(dispatch)
          } else {


            let ResTopJoiner = await OnlineRequestTopJoinerGameClass.OnlineRequestTopJoiner(dispatch)
            let res = await OnlineRequestLeagueListGameClass.OnlineRequestLeagueList(dispatch)

          }

        }
      })

    }

  }
  useEffect(() => {
    GetTopJoinerCompareWithJoin(dispatch)

  }, [JoinCountRedux]);
  // check Use phone Number
  useEffect(() => {
    {
      // console.log('redirect 1 ')
      window.location.hostname === "newpanel.membersgram.com" || "webapp.membersgram.com" || "http://localhost:3000" && (

        history.push(`/`)
      )
    }
    (async function () {
      let res = await GetUpdatedTelegramAccont()

      if (res.length == 0) {
        let localFullScreen = localStorage.getItem("LoginTelegramDialoge");

        if (window.location.href.indexOf("LoginTelegram") >= 0) {

        } else {
          let Token = GetCookie('Token');
          let active = GetCookie('active');
          if (Token !== null) {
            if (active === 'true') {
              if (localFullScreen == undefined) {
                localStorage.setItem("LoginTelegramDialoge", 1)
                // dispatch(SetLoginTelegramDialogeState(true))
              } else if (localFullScreen == 1) {
                localStorage.setItem("LoginTelegramDialoge", 2)
                // dispatch(SetLoginTelegramDialogeState(true))
              } else if (localFullScreen == 2) {
                localStorage.setItem("LoginTelegramDialoge", 3)
                // dispatch(SetLoginTelegramDialogeState(true))
// 
              }
            }
          }
        }


      } else {

        dispatch(SetLoginTelegramDialogeState(false))
      }
    })();

  }, [])
  const GetUpdatedTelegramAccont = async () => {
    let TelegramAccountUpdate = await TelegramDB.Data.toArray()
    // setTelegramAccount(TelegramAccountUpdate)
    return TelegramAccountUpdate
  }



  useEffect(() => {
    // CheckUserIp()
    CheckJoinFunction(dispatch)
  }, [])

  const CheckJoinFunction = async (dispatch) => {
    const CheckDataBaseJoinClass = new CheckDataBaseJoin();
    let TelegramDbRes = await CheckDataBaseJoinClass.CheckAccounts(dispatch);
  }


  // const [CountryName, setCountryName] = useState('')
  // useEffect(() => {
  //   fetch("http://ip-api.com/json")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       // setIp(data.ip);
  //       console.log(data) 
  //       setCountryName(data.country);
  //     })
  //     .catch((err) => console.error("IP info fetch error:", err));
  // }, []);
  // const CheckUserIp = async () => {

  //   try {
  //     const res = await axios.get("http://ip-api.com/json");
  //     // const res = await axios.get("https://ipapi.co/json/");


  //     data.countries.map(item => {

  //       if (res.data.country.toLocaleLowerCase().indexOf(item.name.toLocaleLowerCase()) >= 0) {
  //         // if (res.country_name.toLocaleLowerCase().indexOf(item.name.toLocaleLowerCase()) >= 0) {
          



  //         setCountryName(item.name)

  //       }
  //     })
  //   } catch (error) {

  //   }
  // }
  // console.log(CountryName)
  return (
    <div className={"App " + Mode} >
      <Promotion />
      <Congratulations />
      <Congratulations2 />
      <Congratulations3 />
{/* <PushTest /> */}
      <LoginTelegramDialoge />
      <Router>
        <Switch>

           <Route exact path="/" component={Auth} /> 
         {/* <Route exact path="/" component={CountryName === "Iran" ? IranAuth : Auth} />*/}

          <Route path="/Intro" component={Intro} />
          <Route path="/Login" component={Login} />
          <Route path="/Register" component={Register} />
          <Route path="/RegisterGetPassword" component={RegisterGetPassword} />
          <Route path="/Home" component={Home} />
          <Route path="/GetPhoneNumber" component={GetPhoneNumber} />
          <Route path="/CheckVerificationCode" component={CheckVerificationCode} />
          <Route path="/ForgetPassword" component={ForgetPassword} />
          <Route path="/ForgetPasswordGetCode" component={ForgetPasswordGetCode} />
          <Route path="/ChangePassword" component={ChangePassword} />
          <Route path="/Coin" component={Coin} />
          <Route path="/LoginTelegram" component={LoginTelegram} />
          <Route path="/VerifyCode" component={VerifyCode} />
          <Route path="/JoinBot" component={JoinBot} />
          <Route path="/AutoManualJoin" component={AutoManualJoin} />
          <Route path="/Notice" component={Notice} />
          <Route path="/GetLinkUsername" component={GetLinkUsername} />
          <Route path="/GetUsernameView" component={GetUsernameView} />

          <Route path="/TransferHistory" component={TransferHistory} />
          <Route path="/GiftCode" component={GiftCode} />
          <Route path="/Profile" component={Profile} />
          <Route path="/AccountInformation" component={AccountInformation} />
          <Route path="/Payments" component={Payments} />
          <Route path="/LogOut" component={LogOut} />
          <Route path="/DeleteAccount" component={DeleteAccount} />
          <Route path="/AddNumber" component={AddNumber} />
          <Route path="/AddNumberVerify" component={AddNumberVerify} />
          <Route path="/EditNumber" component={EditNumber} />
          <Route path="/EditNumberVerify" component={EditNumberVerify} />
          <Route path="/EditProfile" component={EditProfile} />
          <Route path="/SetName" component={SetName} />
          <Route path="/PhotoUpload" component={PhotoUpload} />


          <Route path="/Orders" component={Orders} />
          <Route path="/OrderDetailsSingle" component={OrderDetailsSingle} />
          <Route path="/OrderDetailsAll" component={OrderDetailsAll} />
          <Route path="/Privacy" component={Privacy} />
          <Route path="/SetPassword" component={SetPassword} />
          <Route path="/GetCheckPassword" component={GetCheckPassword} />
          <Route path="/GetChangePassword" component={GetChangePassword} />

          <Route path="/Game" component={Game} />
          <Route path="/AllReward" component={AllReward} />
          <Route path="/PreviousTournament" component={PreviousTournament} />


          <Route path="/SellingPhoneNumbers" component={SellingPhoneNumbers} />
          <Route path="/SaleHistory" component={SaleHistory} />

          <Route path="/VerificationCode" component={VerificationCode} />
          <Route path="/VerifyTelegramCodeLogin" component={VerifyTelegramCodeLogin} />
          <Route path="/JoinBotLoginTelegram" component={JoinBotLoginTelegram} />
          <Route path="/AddEmail" component={AddEmail} />
          <Route path="/AddEmailSetPassword" component={AddEmailSetPassword} />
          <Route path="/SelectEmoji" component={SelectEmoji} />
          <Route path="/ReactionGetPostLink" component={ReactionGetPostLink} />



        </Switch>
      </Router>
      <Update />
      <SnackBarEndLeague />
    </div>
  );
}

export default App;
